import { useCallback } from 'react';

// Smoothly scroll the window back to the top. Lenis hijacks native scrolling,
// so we call its API when present and fall back to the browser otherwise.
// Returns a stable callback: `const scrollToTop = useScrollToTop();`
export default function useScrollToTop() {
    return useCallback((target = 0) => {
        if (window.lenis) window.lenis.scrollTo(target);
        else window.scrollTo({ top: target, behavior: 'smooth' });
    }, []);
}
